<template>
      <!-- max-height="500" -->

  <div class="tableStyle">
    <el-table
      v-on="$listeners"
      v-bind="$attrs"
      ref="elTable"
      highlight-current-row
      row-key="id"
      :data="tableData ? tableData : resultData.data"
      :cell-class-name="cellClassName"
      :header-cell-class-name="headercellClassName"
      fit
      border
      :row-style="{
        color: '#1e1e1e',
        'font-size': '14px',
      }"
      :header-cell-style="{
        'background-color': '#f8f8f8',
        'font-size': '14px',
        color: '#7c7c7c',
        height: '50px',
        'border-bottom': 'solid 1px #e0e0e0',
      }"
    >
      <slot slot="empty" name="empty">
        <el-empty description=""></el-empty>
      </slot>
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->

      <el-table-column
        :label="item.label"
        show-overflow-tooltip
        :prop="item.model"
        v-for="item in columnArr"
        :key="item.model"
      ></el-table-column>
      <slot></slot>
    </el-table>
    <div id="table_foo" v-if="resultData.total">
      <span>共{{ resultData.total }}个</span>
      <el-pagination
        @current-change="currentChange"
        @size-change="sizeChange"
        background
        :page-sizes="[10, 50, 100, 500]"
        :current-page="formParams.current"
        :layout="isshowsize ? 'prev, sizes,pager, next' : 'prev,pager,next'"
        :page-size="formParams.size"
        :total="resultData.total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  props: {

    isshowsize: {
      default: false,
      type: Boolean,
    },
    bind_callBack: Function /* 这个函数只有EPC绑定的时候采用 */,
    tableData: {
      type: Array,
    },
    axiosType: Boolean,
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isSearch: {
      type: Boolean,
      default: true,
    },
    url: String,
    columnArr: Array,
  },
  data() {
    return {
      formParams: {
        current: 1,
        size: 10,
      },
      resultData: {
        data: [],
        totla: 0,
      },
    };
  },

  mounted() {},
  methods: {
    set_checket(row) {
      this.$refs["elTable"].toggleRowSelection(row);
    },
    sizeChange(data) {
      this.formParams.size = data;
      this.defaultSerch();
    },
    /* 默认选中 */
    toggleRowSelection(arr) {
      if (arr && arr.length) {
        this.$nextTick(() => {
          for (let i = 0; i < arr.length; i++) {
            this.$refs["elTable"].toggleRowSelection(arr[i], true);
          }
        });
      }
    },
    currentChange(page) {
      this.formParams.current = page;
      this.defaultSerch();
    },
    defaultSerch() {
      if (this.axiosType) {
        this.$requestAxiosForm(
          {
            url: this.url,
            data: Object.assign(this.formParams, this.params),
          },
          (data) => {
            this.resultData = data;
          }
        );
      } else {
        this.$requestAxios(
          {
            url: this.url,
            data: Object.assign(this.formParams, this.params),
          },
          (data) => {
            this.resultData = data;
          }
        );
      }
    },
    search() {
      this.$set(this.formParams, "current", 1);

      if (this.axiosType) {
        this.$requestAxiosForm(
          {
            url: this.url,
            data: Object.assign(this.formParams, this.params),
          },
          (data) => {
            this.resultData = data;
            if (this.bind_callBack && data.data.length == 1) {
              this.bind_callBack(data.data);
            }
          }
        );
      } else {
        this.$requestAxios(
          {
            url: this.url,
            data: Object.assign(this.formParams, this.params),
          },
          (data) => {
            this.resultData = data;
            if (this.bind_callBack && data.data.length == 1) {
              this.bind_callBack(data.data);
            }
          }
        );
      }
    },
    init() {
      if (this.url && this.isSearch) {
        this.defaultSerch();
      }
    },
    headercellClassName({ row, column, rowIndex, columnIndex }) {
      if (
        column.type !== "selection" &&
        columnIndex == 0 &&
        column.label !== "单选"
      ) {
        return "firstcell";
      }
    },
    // 首个单元格样式修改
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (
        column.type !== "selection" &&
        columnIndex == 0 &&
        column.label !== "单选"
      ) {
        return "firstcell";
      }
      if (column.type == "selection" && columnIndex == 0) {
        return "selectionfirstcell";
      }
    },
  },
};
</script>
<style scoped></style>
